module.exports = __webpack_public_path__ + "static/media/zhongjiang.19dd085.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/zhongjiang.mp3
// module id = 9fOv
// module chunks = 1